import styled from "styled-components";
import Theme from "../../../../Styles/Themes";
import config from "../../../../Config/config.json"
import { motion } from "framer-motion";

import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    flex-direction: column;
    border-radius: 40px;
    transition: 0.5s;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 80%;
    filter: ${(props) => (props.$active ? 'grayscale(0)' : 'grayscale(100)')};
    position: relative;
    @media (min-width: 1281px) {
        padding-top: 15px;
        padding-bottom: 15px;
    }
`;

export const ContainerIcon = styled.a`
    display: flex;
    justify-content: ${props => props.$aling};
    align-items: center;
    padding: 10px;
    width: 100%;
    border-radius: 10px;
    background: ${(props) => (props.$show ? '#014642' : props.$select ? '#014642' : 'transparent')};
    border: none;
    cursor: ${props => props.$function ? 'pointer': 'auto'};
    outline: none;
    color: ${props => props.$function ? '#F2F2F2': '#A3A3A3'};
    font-weight: 600;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    line-height: ${Theme[config.theme].font.labels['small'].line_height};
    transition: 0.8s;
    gap: 15px;
    text-decoration: none;
    overflow: hidden;
    &:hover {
        background: ${(props) => (props.$function ? '#014642' : 'transparent')};
    }
    @media (min-width: 1281px) {
        padding: 15px;
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    }
`;

export const SideBarIcon = styled(SVG)`
    width: 30px;
    height: 30px;
    align-self: center;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 1281px) {
        width: 30px;
        height: 30px;
    }
`;

export const SubItensContainer = styled(motion.div)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    margin-left: 10px;
`;

export const TextItem = styled.p`
    display: flex;
    justify-content: ${props => props.$aling};
    align-items: center;
    padding: 15px;
    width: 100%;
    border-radius: 10px;
    border: none;
    cursor: ${props => props.$function ? 'pointer': 'auto'};
    outline: none;
    color: ${props => props.$function ? '#F2F2F2': '#A3A3A3'};
    font-weight: 600;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    line-height: ${Theme[config.theme].font.labels['small'].line_height};
    transition: 0.8s;
    gap: 15px;
    text-decoration: none; 
    @media (min-width: 1281px) {
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    }
`;

export const ContainerSvg = styled.div`
    width: 30px;
    height: 30px;
    @media (min-width: 1281px){
        width: 30px;
        height: 30px;
    }
`;